import { render, staticRenderFns } from "./priority-column.vue?vue&type=template&id=0b3d1b46"
import script from "./priority-column.vue?vue&type=script&lang=js"
export * from "./priority-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports